import React from 'react'
import { Icon, Animation, PageTitle, PageContent, Heading, Button } from 'components/library'
import { withApp } from 'helpers'
import './Page.css'

class Page extends React.Component {
  state = {
    list: [
      { id: 1, title: 'Checklist Train de Trainer', file: process.env.PUBLIC_URL+'/trainer-toolkit/checklist_train_the_trainer.pdf' },
      { id: 2, title: 'Praktijkopdrachten Pushback', file: process.env.PUBLIC_URL+'/trainer-toolkit/overzicht_opdrachten_pushback.pdf' },
      { id: 3, title: 'Praktijkopdrachten Sleep', file: process.env.PUBLIC_URL+'/trainer-toolkit/overzicht_opdrachten_sleep.pdf' },
      { id: 4, title: 'Richtlijnen Theorie-examen Sleep & Pushback', file: process.env.PUBLIC_URL+'/trainer-toolkit/toelichting_theorie_examens.pdf' },
      { id: 5, title: 'Richtlijnen Praktijkexamen Pushback', file: process.env.PUBLIC_URL+'/trainer-toolkit/praktijktoets_pushback.pdf' },
      { id: 6, title: 'Richtlijnen Praktijkexamen Sleep', file: process.env.PUBLIC_URL+'/trainer-toolkit/praktijktoets_sleep.pdf' },
      { id: 7, title: 'Ritregistratie', file: process.env.PUBLIC_URL+'/trainer-toolkit/ritregistratie-capp.xlsx' },
    ]
  }

  componentDidMount() {
    this.props.updateProgress()
    if(window.localStorage && localStorage.getItem('sleep-trainer-toolkit')!=='1'){
      this.props.app.toggleModal(null, 'coach-modal')
    }
  }

  render() {
    return (
      <div className="Trainer-toolkit">

        <Animation name="slideInDown" delay={100}>
          <PageTitle>
            <Heading h1>{this.props.page.title}</Heading>
          </PageTitle>
        </Animation>

        <Animation delay={200}>
          <PageContent className="Trainer-toolkit-content">
            <div className="Trainer-cards">
              {this.state.list.map(item => (
                <div key={item.id}>
                  <div className="Trainer-card">
                    <Heading h3>{item.title}</Heading>
                    <a className="Trainer-card-download" style={{transform: "rotate(90deg)"}} href={item.file} download={item.title} target="_blank">
                      <Icon name="logout" />
                    </a>
                  </div>
                </div>
              ))}
            </div>

            <div className="Trainer-card-info">
              <div className="Trainer-card-info-trigger" onClick={() => this.props.app.toggleModal(null, 'coach-modal')}>
                <Icon name="info" />
              </div>
            </div>

            <div style={{ textAlign: 'center', margin: '6rem 0 2rem' }}>
              <Button fixed square primary onClick={this.props.onSubmit} label="Ga naar overzicht" />
            </div>
          </PageContent>
        </Animation>
      </div>
    )
  }
}

export default withApp(Page)



// WEBPACK FOOTER //
// ./src/content/pages/trainer-toolkit/Page.js